// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3V4Ue","left":"styles_left__2cSqk","right":"styles_right__3_R-Y","alert":"styles_alert__39jS2"};